import { API } from "aws-amplify";
import listStreams from "./listStreams";
import { isEmpty } from "lodash";

const ALLOWED_PROPERTIES = [
  'companyId',
  'features',
  'iotThingName',
  'latitude',
  'longitude',
  'rtspUrl',
  'rtspUrlProc',
  'siteId',
  'defaultName',
  'ptz',
  'state',
  'cvParameters',
  'tags',
  'type',
  'manufacturer',
  'position',
  'fovWidth',
  'range',
  'angleEastOfNorth',
  'retentionPeriodInHours',
  'sourceType',
  'hardwareDetails',
  'youtubeStreamKey',
  'speedLimitMph'
]

async function updateStream(stream: VideoStreamBase): Promise<VideoStream> {
  try {
    const path: string = `/streams/${stream.siteId}/${stream.kvsName}`;
    const tempStream: any = {
      ...stream
    }
    delete tempStream.kvsName
    if (tempStream.deviceShadowName) delete tempStream.deviceShadowName;
    if (!tempStream.retentionPeriodInHours) delete tempStream.retentionPeriodInHours;

    Object.keys(tempStream).forEach((key) => {
      if (!ALLOWED_PROPERTIES.includes(key)) {
        delete tempStream[key];
      }
    })

    if (tempStream.ptz) {
      if (tempStream.ptz.mjpegUrl === null) tempStream.ptz.mjpegUrl = ""
      if (tempStream.ptz.onvifPassword === null) tempStream.ptz.onvifPassword = ""
      if (tempStream.ptz.onvifUser === null) tempStream.ptz.onvifUser = ""
    }

    if (isEmpty(tempStream.position)) {
      delete tempStream.position;
    }

    const options = {
      body: tempStream
    };

    await API.put(
      'api-service',
      path,
      options
    );

    const streams = await listStreams(stream.siteId, stream.companyId);
    return streams.find(el => el.kvsName === stream.kvsName) as VideoStream;
  } catch (error: any) {
    throw error;
  }
}

export default updateStream;
